<footer class="footer d-none d-lg-block container-fluid full-width">
	<div class="container">
		
		<p class="text-muted text-center" style="font-size: 15px; color: #0088f2;">
			<a href="tel: 877-700-1494">Contact Us (877) 700 1494 </a>
			<a class="nav-link pt-3" href="mailto:leads@resmac.com"></a>
		</p>
		<div class="row">
			<p class="text-muted text-center" style="font-size: 10px;">
				© 2020 ResMac, Inc. a Florida corporation headquartered at 1500 Gateway Blvd, Suite 220, Boynton Beach, FL 33426, NMLS# 153098.
			</p>
		</div>
	</div>
</footer>


